import { SettingsLayout } from 'modules/settingsContainer/SettingsLayout';
import { DataTab } from 'modules/visualisations/Waterfall/settings/DataTab';
import { ViewTab } from 'modules/visualisations/Waterfall/settings/ViewTab';

export const WaterfallMainSettings = () => {
  return <SettingsLayout DataComponent={DataTab} ViewComponent={ViewTab} />;
};
